<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
    <b-card>
          <div slot="header">
            <strong>Riderwise Product Details</strong>
           <div class="card-header-actions" >                
             
            </div>
          </div>
            <b-row class="mb-1">          
<!-- 
                <b-col md="6" class="my-1">
                    <b-col sm="12" >
                   <b-form-group label="Delivery Agent"  label-size="sm"
                      :label-cols="3" >                   
                      <v-select id="mySelect" v-model="selectedagent" :options="this.data1" @input="getclaimwisecount" placeholder="Search" name="selectedagent" v-validate="'required'" :class="{ danger: errors.has('selectedagent') }">
                      </v-select>
                    
                    </b-form-group> 
                    </b-col>   
                </b-col> --> 

                  <b-col sm="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
             
                 
              
              </b-row>
    
               <div id="overlay" >
             <div class="loader"></div>
           </div>

 
             <b-row>
              <b-col sm="12" class="text-right">
                <!-- <b-button v-if="this.total_row_product >0"  @click="downloadCSV" variant="primary" size="md" >Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
              </b-col> 
          </b-row>

        <b-col sm="12" >
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>
             <template slot="action" slot-scope="row">
              <div>
            <!--  <router-link
        to="/riderwise_productdetails"
      >     -->
              <b-button v-b-tooltip.hover title="Product Details" size="sm"  style="background: #b0c4de !important;color: #000 !important;" class="mr-1">
                    View
                  </b-button>
          <!-- </router-link> -->
              </div>
              
             </template>
          </b-table>
        </b-col>
          <b-col md="12" class="my-1 " >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>   

         

        
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'riderwise_productdetails', 
  data: function() {
    return {
        name: 'riderwise_productdetails',
        isBusy: false,           
        items:[
        { shippingid: 'FUSMA72979',  productid: 'P78393',productname: 'Toys',hsncode:'6827263',productquantity:'10',productvalue:'100',
        countrycode:'BHR',countryoforigin:'Dubai',
        modetransport:'Air' },
        { shippingid: 'FUSMA72980',  productid: 'P78390',productname: 'Cloth',hsncode:'6827298',productquantity:'20',productvalue:'100',
        countrycode:'BHR',countryoforigin:'Dubai',
        modetransport:'Road' },
        
        ],
        grandtotal:0,
        data1:[],
        fields: [
         { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productid', label: 'Product ID', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productname', label: 'Product Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'hsncode', label: 'HSN Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productquantity', label: 'Product Quantity', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productvalue', label: 'Product Value', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'countrycode', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'countryoforigin', label: 'Country Of Origin', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
            { key: 'modetransport', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
              
                                         
         ], 
        bordered: true,
        totalRows: 2,
        currentPage: 1,
        perPage:  20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        filter: null,
        currenthubidselct:'',
        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        selectedagent:'',
        showReverse:false,
        reversecountdetails:false,
         reverse_listing:[],
         reversecountdetail:[],

        // showValues:false
    }
  },
  created: function() {  
    // this.displaydata();
    // this.getclaimwisecount();
    
  },
 
  methods: {
    // getclaimwisecount:function(){
      
    // },
    
   // riderwiseproductdetails:function(){

   // };
    

    displaydata: function () {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        const deliveryagentobj = {
          deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
          isactive: '1',
           hub_id:`${userInfo.pickuplocationmasterid}`,
        }
  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagentobj)
  .then(result => {
            this.data1 = result.body;          
            var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentfirstname+ '  '+srData.deliveryagentlastname+ ' - '+srData.deliveryagentmasterid
                });
              });
              this.data1 = data;
              this.data1.unshift({"label": "All", "key": 0});

        }).catch(ex => {
            console.log('error-----', ex)
        });
    }
    
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+' : '+ " " + strTime;
      }
    }
  }
 
};
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

   #mySelect  {
   width: 230px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
